export const radiobutton = {
  root: {
    width: "18px",
    height: "18px",
    background: "{form.field.background}",
    checkedBackground: "{form.field.background}",
    checkedHoverBackground: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.border.color}",
    checkedBorderColor: "{primary.support}",
    checkedHoverBorderColor: "{primary.default}",
    checkedFocusBorderColor: "{primary.default}",
    checkedDisabledBorderColor: "{form.field.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    shadow: "{form.field.shadow}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      width: "12px",
      height: "12px",
    },
    lg: {
      width: "24px",
      height: "24px",
    },
  },
  icon: {
    size: "14px",
    checkedColor: "{primary.support}",
    checkedHoverColor: "{primary.default}",
    disabledColor: "{form.field.disabled.color}",
    sm: {
      size: "10px",
    },
    lg: {
      size: "18px",
    },
  },
};
